import script from "./FiltersBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersBar.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersBar.vue?vue&type=style&index=0&id=57420eef&lang=scss"

const __exports__ = script;

export default __exports__